/* jshint esversion: 6 */
/* jshint esversion: 11 */
import { useEffect, useState, useCallback, useContext } from 'react';
import { MyContext } from '../../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';

const Razorpay = ({ Amount, attributes }) => {

    const { setPaymentRes, setTransactionId, setPaymentLod } = useContext(MyContext);

    const [userData, setUserData] = useState();

    const openPayModal = useCallback(() => {
        setPaymentLod(false);
        const options = {
            key: attributes,
            amount: Amount * 100,
            name: "MegicMate",
            description: "some description",
            image: "https://cdn.razorpay.com/logos/7K3b6d18wHwKzL_medium.png",
            handler: (response) => {
                setPaymentRes("PaymentDone");
                setTransactionId(response.razorpay_payment_id);
            },
            modal: {
                ondismiss: () => {
                    setPaymentRes("PaymentFaild");
                }
            },
            prefill: {
                name: userData && userData?.name,
                contact: userData && userData?.mobile,
                email: userData && userData?.email,
            },
            notes: {
                address: "some address",
            },
            theme: {
                color: "#F37254",
                hide_topbar: false,
            },
        };

        const rzp1 = new window.Razorpay(options);
        rzp1.open();

    }, [Amount, userData]);

    useEffect(() => {
        const localData = secureLocalStorage.getItem("LoginData");

        if (!Amount || !localData) return;

        const parsedData = JSON.parse(localData);
        setUserData(parsedData)
    }, [Amount]);

    useEffect(() => {
        if (userData && Amount) {
            openPayModal();
            sessionStorage.setItem("Amount", Amount);
        }
    }, [Amount, userData]);

    return null;
};

export default Razorpay;
